module.exports = __webpack_public_path__ + "static/Presentation-coaching-SLAP-digital-13d5453f99241edb4e808aa8c63fd088.pdf";